import React, { memo } from 'react';
import { withRouter } from 'react-router';
import checkReadOnly from '../../connectedForm/utils/checkReadOnly';
import { FormLink } from '../../../utils/LinkUtils';
import getIn from '../../connectedForm/utils/getIn';
import { IFormatterProps } from '../../../@types/workspaceTypes';

const LinkFormatter = (props: IFormatterProps) => {
  // Don't render component if it is conditional and condition not satisfied
  const values = props.dependentValues;
  const options = values.options;
  if (options.condition && !options.condition(values.rowData)) {
    return null;
  }

  const {
    rowData,
    options: { title, readOnlyStatus, linkField },
  } = props.dependentValues;

  const link = getIn(props.dependentValues, linkField || 'options.link');
  if (!rowData) return <div />;
  let label = title;
  const readOnly = checkReadOnly(readOnlyStatus, rowData);
  if (readOnly) label = 'View';
  if (!label) {
    label = 'Select';
  }

  const dataTestId = `datagrid-link-icon-${props.rowIdx}`;
  const LinkIcon = linkField ? (
    <div className="textlink" data-testid={dataTestId}>
      {link}
    </div>
  ) : (
    <div className="linkIcon" data-testid={dataTestId}>
      {link || 'navigate_next'}
    </div>
  );

  return <FormLink {...props} icon={LinkIcon} tabIndex={-1} title={label} />;
};

const MemoizedLinkFormatter = memo<IFormatterProps>(
  LinkFormatter,
  (prevProps: IFormatterProps, nextProps: IFormatterProps) => {
    const { dependentValues } = nextProps;
    const readOnly = !!(dependentValues && dependentValues.options && dependentValues.options.readOnlyStatus);
    return nextProps.value === prevProps.value && !readOnly;
  }
);

//Casting the component to 'any' due to some obscure issues noted in the types for react-router.
//Likely to resolve itself if/when we upgrade react-router to 6+
export default withRouter(MemoizedLinkFormatter as any);
